/**
 * Formatters shared by the per-type detail bodies (CT-5092/CT-5093). Extracted
 * so `confidencePercent` / `formatDate` live in one place instead of being copied
 * byte-for-byte into each body component.
 */

/** Confidence arrives as 0–1 (fixtures) or 0–100 (GS); normalize to a percent. */
export function confidencePercent(value) {
  const numeric = Number(value);
  if (!Number.isFinite(numeric)) return null;
  const ratio = numeric > 1 ? numeric / 100 : numeric;
  return `${Math.round(Math.min(1, Math.max(0, ratio)) * 100)}%`;
}

/** Localized short date, or null for a missing/invalid ISO string. */
export function formatDate(iso) {
  if (!iso) return null;
  const date = new Date(iso);
  return Number.isNaN(date.getTime()) ? null : date.toLocaleDateString();
}

/**
 * Prototype-style timestamp for message cards (e.g. "Jul 2, 02:30 AM").
 * Accepts ISO from API or a pre-formatted display string from fixtures.
 */
export function formatMessageDateTime(value, locale) {
  if (!value) return null;
  const raw = String(value).trim();
  if (!raw) return null;
  // Fixtures / render may already ship a display string.
  if (!raw.includes('T') && !/^\d{4}-\d{2}-\d{2}/.test(raw)) {
    return raw;
  }
  const ts = Date.parse(raw);
  if (Number.isNaN(ts)) return null;
  try {
    return new Intl.DateTimeFormat(locale || undefined, {
      month: 'short',
      day: 'numeric',
      hour: 'numeric',
      minute: '2-digit',
    }).format(ts);
  } catch {
    return null;
  }
}
